import * as React from 'react';
import { useContext, createContext } from 'react';

const TooltipContext = /*#__PURE__*/ createContext(null);
TooltipContext.displayName = 'TooltipContext';
const useTooltip = ()=>{
    const context = useContext(TooltipContext);
    if (context === null) {
        throw new Error('No TooltipContext available.');
    }
    return context;
};
const TooltipProvider = ({ value , children  })=>{
    return /*#__PURE__*/ React.createElement(TooltipContext.Provider, {
        value: value
    }, children);
};

export { TooltipContext, TooltipProvider, useTooltip };
//# sourceMappingURL=TooltipContext.js.map
